<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
  <div class="form-group row">
    <div class="col-md-12">
      <yt-dropdown-picklist [ModelName]="'zaposleni'" [GetName]="'get'" [ModelProperty]="'Prezime,Ime'" [GetParameters]="modelData.MainList.GetParameters"
        formControlName="OsobaId" [Label]="'STRUCNOUSAVRSAVANJE.OSOBA.SINGULAR'" [ngClass]="{'is-invalid': submitted && fc.OsobaId.invalid}"
        #autofocus>
      </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.OsobaId.invalid">
        <span *ngFor="let validation of errorMessages.OsobaId">
          <span class="error-message" *ngIf="fc.OsobaId.hasError(validation.type)">
            <span translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-6">
      <yt-dropdown-picklist 
      [ModelName]="'tippotvrdeostrucnomusavrsavanju'" 
      [GetName]="'get'" 
      [ModelProperty]="'Naziv'"
      [GetParameters]="modelData.MainList.GetParameters" 
      formControlName="TipPotvrdeOStrucnomUsavrsavanjuId" 
      [Label]="'STRUCNOUSAVRSAVANJE.TIPPOTVRDEOSTRUCNOMUSAVRSAVANJU.SINGULAR'"
      [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}">
      </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.TipPotvrdeOStrucnomUsavrsavanjuId.invalid">
        <span *ngFor="let validation of errorMessages.TipPotvrdeOStrucnomUsavrsavanjuId">
          <span class="error-message" *ngIf="fc.TipPotvrdeOStrucnomUsavrsavanjuId.hasError(validation.type)">
            <span translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <yt-dropdown-picklist [ModelName]="'tipstrucnogusavrsavanja'" [GetName]="'get'" [ModelProperty]="'Naziv'"
        [GetParameters]="modelData.MainList.GetParameters" formControlName="TipStrucnogUsavrsavanjaId" [Label]="'STRUCNOUSAVRSAVANJE.TIPSTRUCNOGUSAVRSAVANJA.SINGULAR'"
        [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}">
      </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.TipStrucnogUsavrsavanjaId.invalid">
        <span *ngFor="let validation of errorMessages.TipStrucnogUsavrsavanjaId">
          <span class="error-message" *ngIf="fc.TipStrucnogUsavrsavanjaId.hasError(validation.type)">
            <span translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-12">
      <yt-input [Type]="'text'" [Label]="'STRUCNOUSAVRSAVANJE.NAZIV.SINGULAR'" name="txtNaziv" 
        formControlName="Naziv" [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
        <span *ngFor="let validation of errorMessages.Naziv">
          <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-12">
      <yt-input [Type]="'text'" [Label]="'STRUCNOUSAVRSAVANJE.PREDAVAC.SINGULAR'" name="txtPredavac" #autofocus
        formControlName="Predavac" [ngClass]="{'is-invalid': submitted && fc.Predavac.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Predavac.invalid">
        <span *ngFor="let validation of errorMessages.Predavac">
          <span class="error-message" *ngIf="fc.Predavac.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>
  
  <div class="form-group row">
    <div class="col-md-9">
      <yt-fw-date-picker-popup formControlName="Datum" name="txtDatDok" [Label]="'STRUCNOUSAVRSAVANJE.DATUM.SINGULAR'"
        [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
        <span *ngFor="let validation of errorMessages.Datum">
          <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>   
    <div class="col-md-3">
      <yt-input [Type]="'text'" [Label]="'STRUCNOUSAVRSAVANJE.TRAJANJE.SINGULAR'" name="txtTrajanje" #autofocus
        formControlName="Trajanje" [ngClass]="{'is-invalid': submitted && fc.Trajanje.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Trajanje.invalid">
        <span *ngFor="let validation of errorMessages.Trajanje">
          <span class="error-message" *ngIf="fc.Trajanje.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>

  </div>

  <div class="form-group row">
    <div class="col-md-6">
      <yt-fw-date-picker-popup formControlName="RealizovanOdDatuma" name="txtDatOd" [Label]="'STRUCNOUSAVRSAVANJE.REALIZOVANOODDATUMA.SINGULAR'"
        [ngClass]="{'is-invalid': submitted && fc.RealizovanOdDatuma.invalid}">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.RealizovanOdDatuma.invalid">
        <span *ngFor="let validation of errorMessages.RealizovanOdDatuma">
          <span class="error-message" *ngIf="fc.RealizovanOdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <yt-fw-date-picker-popup formControlName="RealizovanDoDatuma" name="txtDatDo" [Label]="'STRUCNOUSAVRSAVANJE.REALIZOVANODODATUMA.SINGULAR'"
        [ngClass]="{'is-invalid': submitted && fc.RealizovanDoDatuma.invalid}">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.RealizovanDoDatuma.invalid">
        <span *ngFor="let validation of errorMessages.RealizovanDoDatuma">
          <span class="error-message" *ngIf="fc.RealizovanDoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-8">
      <yt-input [Type]="'text'" [Label]="'STRUCNOUSAVRSAVANJE.INSTITUCIJA.SINGULAR'" name="txtInstitucija" #autofocus
        formControlName="Institucija" [ngClass]="{'is-invalid': submitted && fc.Institucija.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Institucija.invalid">
        <span *ngFor="let validation of errorMessages.Institucija">
          <span class="error-message" *ngIf="fc.Institucija.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-md-2">
      <yt-input [Type]="'text'" [Label]="'STRUCNOUSAVRSAVANJE.KATALOSKIBROJ.SINGULAR'" name="txtKataloskiBroj" #autofocus
        formControlName="KataloskiBroj" [ngClass]="{'is-invalid': submitted && fc.KataloskiBroj.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.KataloskiBroj.invalid">
        <span *ngFor="let validation of errorMessages.KataloskiBroj">
          <span class="error-message" *ngIf="fc.KataloskiBroj.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-md-2">
      <yt-input [Type]="'text'" [Label]="'STRUCNOUSAVRSAVANJE.BROJBODOVA.SINGULAR'" name="txtBrojBodova" #autofocus
        formControlName="BrojBodova" [ngClass]="{'is-invalid': submitted && fc.BrojBodova.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.BrojBodova.invalid">
        <span *ngFor="let validation of errorMessages.BrojBodova">
          <span class="error-message" *ngIf="fc.BrojBodova.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-12">
      <yt-input
        [Type]="'text'"
        [Label]="'STRUCNOUSAVRSAVANJE.MESTO.SINGULAR'"
        name="txtMesto"
        #autofocus
        formControlName="Mesto"
        [ngClass]="{'is-invalid': submitted && fc.Mesto.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Mesto.invalid">
        <span *ngFor="let validation of errorMessages.Mesto">
          <span class="error-message" *ngIf="fc.Mesto.hasError(validation.type)">
            <span translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-form-label col-10"><span translate="STRUCNOUSAVRSAVANJE.USVOJSTVUPREDAVACA.SINGULAR"></span></label>
    <div class="col-md-1">
      <input
        style="width: 20px;"
        type="checkbox"
        name="txtPredavac"
        class="form-control"
        formControlName="USvojstvuPredavaca"
        autocomplete="off"
        [ngClass]="{'is-invalid': submitted && fc.USvojstvuPredavaca.invalid}"
        >
    </div>
    <div class="form-error" *ngIf="submitted && fc.USvojstvuPredavaca.invalid">
      <span *ngFor="let validation of errorMessages.USvojstvuPredavaca">
        <span class="error-message" *ngIf="fc.USvojstvuPredavaca.hasError(validation.type)">
          <span translate="{{validation.message}}"></span>
        </span>
      </span>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-form-label col-10"><span translate="STRUCNOUSAVRSAVANJE.OBAVEZNO.SINGULAR"></span></label>
    <div class="col-md-1">
      <input
        style="width: 20px;"
        type="checkbox"
        name="txtObavezno"
        class="form-control"
        formControlName="Obavezno"
        autocomplete="off"
        [ngClass]="{'is-invalid': submitted && fc.Obavezno.invalid}"
        >
    </div>
    <div class="form-error" *ngIf="submitted && fc.Obavezno.invalid">
      <span *ngFor="let validation of errorMessages.Obavezno">
        <span class="error-message" *ngIf="fc.Obavezno.hasError(validation.type)">
          <span translate="{{validation.message}}"></span>
        </span>
      </span>
    </div>
  </div>

</form>